module.exports = __webpack_public_path__ + "img/restoration-logo.9ef98fd3.png";